/*
 * Copyright (C) 2025 SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { ReactComponent as LinkedInLogo } from "cms/assets/images/LinkedIn-logo.svg";

function FooterContact () {
    return (
        <div className="footer-contact footer-column">
            <p className='footer-column-title'>Contact</p>
            <p>
                <a href="mailto:info@simplicitycms.ca">info@simplicitycms.ca</a>
            </p>
            <p>(778) 817-1746</p>
            <p>
                <a href="https://www.linkedin.com/company/simplicitycms/" target="_blank">
                    <LinkedInLogo alt="linked-in-logo" />
                </a>
            </p>
        </div>
    );
}

export { FooterContact };
